// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34j2T"};